const RoutePath = {
  home: "/",
  documents: "/FaultReporter/admin/:type",
  addReport: "/FaultReporter/admin/reports/:type/add/:isArchive/:id?",
  editReport: "/FaultReporter/admin/reports/edit",
  faultDetails: "/FaultReporter/admin/:type/:id/:reportId",
  editCustomerFault:
    "/FaultReporter/admin/customerfacilityfault/:id/edit/fault/:reportId",
  editTrainFault:
    "/FaultReporter/admin/customertrainfault/:id/edit/fault/:reportId",
  manageUser: "/FaultReporter/admin/manage/user/list/data",
  faultForms: "/FaultReporter/customerfaults/:faultType",
  unSubscribeFault:
    "/FaultReporter/unsubscribe/:unSubscribeType/:unSubscribeValue",

  // unSubscribeFault: '/FaultReporter/unsubscribe/:email/:faultValue' : all faults unsubscribe
  // unSubscribeFault: '/FaultReporter/unsubscribe/:refId/:faultValue': in particular refid
  // for eg:
  // https://tf-dev.railapps.mistral-data.net/FaultReporter/unsubscribe/refId/cff2130
  // https://tf-dev.railapps.mistral-data.net/FaultReporter/unsubscribe/email/hsheoran@q3tech.com
};

// http://localhost:3003/FaultReporter/admin/suggestions/1270/

export default RoutePath;
